import type { PropsWithChildren, ReactElement } from 'react';
import { Children, cloneElement, isValidElement } from 'react';

import { useLogger } from '../hooks';
import type { LogParameters } from '../types';

interface LogClickProps {
	params: LogParameters;
}

export function LogClick({ children, params }: PropsWithChildren<LogClickProps>) {
	const logger = useLogger();
	const child = Children.only(children);

	// ✅ `child`가 ReactElement인지 안전하게 체크
	if (!isValidElement(child)) {
		console.warn('LogClick의 children은 ReactElement여야 합니다.');
		return null;
	}

	// ✅ props의 타입을 명확하게 지정하여 TypeScript 오류 해결
	const element = child as ReactElement<{
		onClick?: (...args: unknown[]) => void;
	}>;

	return cloneElement(element, {
		// eslint-disable-next-line consistent-return
		onClick: (...args: unknown[]) => {
			logger.click({
				params: {
					button: `LOG_CLICK_${params.button}`,
					...params,
				},
			});

			if (typeof element.props.onClick === 'function') {
				return element.props.onClick(...args);
			}
		},
	});
}
